<template>
  <div class="admin-dashboard uvoto-dark-theme">
    <header class="event-header">
     <div style="width: 100%; display: flex; align-items: center; justify-content: space-between;">
         <img src="../assets/uvoto.png" alt="Uvoto" class="mini-logo">
         <button @click="mostrarModalConexion = true" :class="['button-pc', { 'is-conected': connected }]">
            {{ connected ? 'Conectado' : 'Conectar a pc' }} 
            <img src="../assets/pc-icon.png" alt="" style="width: 20px;">
         </button>
     </div>
      <div class="event-info">
        <p class="label-evento">Nombre de evento</p>
        <h1 class="event-title poppins-bold">{{ nombreEvento }}</h1>
        <p class="event-subtitle">Pin de acceso <strong>{{ pinSesion }}</strong></p>
      </div>
    </header>

   <div v-if="mostrarModalConexion" class="bottom-sheet-overlay" @click.self="mostrarModalConexion = false">
  <div class="bottom-sheet animate-up" :style="{ height: connected ? '35vh' : '80vh' }">
    <div class="handle"></div>

    <div class="sheet-header">
      <div class="sheet-title-row">
        <h3>{{ connected ? 'Pantalla Vinculada' : 'Vincular Pantalla' }}</h3>
        <button @click="mostrarModalConexion = false" class="btn-close-sheet">×</button>
      </div>
      
      <div v-if="!connected" class="tabs-conexion">
        <button @click="tabConexion = 'qr'" :class="{ active: tabConexion === 'qr' }">Acceso Qr</button>
        <button @click="tabConexion = 'pin'" :class="{ active: tabConexion === 'pin' }">Pin de Ingreso</button>
      </div>
    </div>

    <div class="conexion-content">
      
      <div v-if="connected" class="connected-state-view">
        <div class="status-badge-pulsing">
          <div class="pc-icon-wrapper">
             <img src="../assets/pc-icon.png" class="pc-main-icon">
             <div class="pulse-ring"></div>
          </div>
          <div class="status-text-info">
            <p class="status-online">Transmitiendo en vivo</p>
          </div>
        </div>
        <div class="connection-actions">
          <button @click="desconectarProyector" class="btn-outline-danger">Finalizar Proyección</button>
        </div>
      </div>

      <div v-else class="vinculacion-active-area">
        <div v-if="tabConexion === 'qr'" class="qr-reader-container">
          <qrcode-stream @decode="onDecode" class="camera-stream"></qrcode-stream>
          <p class="hint">Apunta a la pantalla del proyector</p>
        </div>

        <div v-else class="pin-entry-card">
          <div class="pin-grid-admin">
            <input
              v-for="(digit, index) in pinDigitsAdmin"
              :key="index"
              maxlength="1"
              class="pin-box-admin"
              :value="digit"
              inputmode="numeric"
              pattern="[0-9]*"
              @input="onPinAdminInput(index, $event)"
              @keydown="onPinAdminKeydown(index, $event)"
              ref="pinInputsAdmin"
            />
          </div>
          <button @click="conectarPorPin" class="btn-conectar-negro" :disabled="pinProyector.length !== 4">Conectar</button>
        </div>

        <div class="proyector-instructions">
          <div class="inst-divider"></div>
          <h4 class="inst-title">¿Cómo proyectar?</h4>
          <div class="inst-steps">
            <div class="step-item">
                <div class="step-icon">1</div>
                <p>En tu computadora o Smart TV, abre: <strong>web.uvoto.com</strong></p>
            </div>
            <div class="step-item">
                <div class="step-icon">2</div>
                <p>Escanea el QR o ingresa el PIN manual desde esta ventana.</p>
            </div>
            <div class="step-item">
                <div class="step-icon">3</div>
                <p>¡Listo! Podrás mostrar resultados y branding en tiempo real.</p>
            </div>
           <ul class="capabilities-list">

            <li>📊 <strong>Resultados</strong> en tiempo real con gráficas animadas.</li>

            <li>❓ <strong>Preguntas activas</strong> para guiar a tu audiencia.</li>

            <li>🖼️ <strong>Branding</strong> con el logo de tu evento en el fondo.</li>

            </ul>
          </div>
          <div class="tech-note">
            <img src="../assets/pc-icon.png" style="width: 14px; opacity: 0.5;">
            Usa Chrome en pantalla completa (F11) para mejor experiencia.
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

    <main class="content-area">
      <div v-if="preguntas.length === 0" class="empty-state">
        <div class="dashed-box">
          <span>Esperando nuevas creaciones</span>
        </div>
      </div>

     <div v-else class="questions-list">
        <div v-for="pregunta in preguntas" :key="pregunta.id" class="question-card animate-in">
        <h2 class="card-title">{{ pregunta.titulo }}</h2>
        <div class="separator-line"></div>
        <div class="card-metrics">
            <span class="metric">
            <img src="../assets/user.png" alt="" style="width: 20px;"> 
            {{ pregunta.participantes || 0 }}
            </span>
            <span class="metric">Votos: {{ totalVotos(pregunta) }}</span>
            <span class="metric clickable" @click="abrirComentarios(pregunta)">
                <img src="../assets/coment.png" alt="" style="width: 20px;"> 
                {{ pregunta.totalComentarios || 0 }}
                </span>
            
            <button 
            @click="handleAction(pregunta)"
            :class="['status-pill', pregunta.estado]"
            :disabled="pregunta.estado === 'finalizado'"
            >
            {{ getStatusText(pregunta.estado) }}
            <img v-if="pregunta.estado === 'ejecucion'" src="../assets/icon-white.png" class="pill-icon rotate-45">
            <img v-else src="../assets/icon-white.png" class="pill-icon">
            </button>
        </div>
        </div>
        </div>


        <div v-if="mostrarModalComentarios" class="bottom-sheet-overlay" @click.self="cerrarComentarios">
        <div class="bottom-sheet animate-up">
            <div class="sheet-header">
            <div class="handle"></div>
            <div class="sheet-title-row">
                <h3>{{ preguntaSeleccionada?.titulo }}</h3>
                <button @click="cerrarComentarios" class="btn-close-sheet">×</button>
            </div>
            <p class="sheet-subtitle">Comentarios</p>
            </div>

            <div class="comments-list">
            <div v-if="comentariosActivos.length === 0" class="empty-comments">
                Aún no hay comentarios en esta pregunta.
            </div>
            <div v-for="c in comentariosActivos" :key="c.id" class="comment-item">
                <div class="comment-user-info">
                <span class="user-badge" :style="{ background: proyectorConfig.color }">
                    {{ (c.nombre || 'A')[0] }}
                </span>
                <div class="user-meta">
                    <span class="user-name">{{ c.nombre || 'Anónimo' }} • {{ c.edad || '--' }} años</span>
                    <span class="user-vote">Votó: <strong>{{ c.opcionVotada || 'Abierta' }}</strong></span>
                </div>
                </div>
                <p class="comment-text">{{ c.texto }}</p>
            </div>
            </div>
        </div>
        </div>
    </main>

    <footer class="creator-footer">
      <div :class="['creator-card', { expanded: nuevaPregunta.titulo.length > 4 }]">
        <textarea 
          v-model="nuevaPregunta.titulo" 
          placeholder="Haz una pregunta"
          class="question-textarea"
          maxlength="120"
          rows="1"
          @input="adjustTextarea"
        ></textarea>

        <div v-if="nuevaPregunta.titulo.length > 4" class="options-container animate-in">
          <div 
            v-for="(opcion, index) in opciones" 
            :key="index" 
            class="option-row"
          >
            <div class="option-label">{{ getLabel(index) }}</div>
            <input 
              v-model="opciones[index]" 
              :placeholder="index === 0 ? 'Escribe tu respuesta' : 'Siguiente respuesta'"
              class="option-input-dashed"
            >
            <button v-if="opciones.length > 1" @click="eliminarOpcion(index)" class="btn-remove-circle">×</button>
            
            <button v-if="index === opciones.length - 1 && opciones.length < 10" 
                    @click="agregarOpcion" class="btn-add">+</button>
          </div>
        </div>


        
        
        <div class="creator-tools">
          <label class="checkbox-label">
            <input type="checkbox" v-model="permitirComentarios">
            <span class="custom-check"></span> 
            <span class="check-label-text">Comentarios</span>
          </label>
          
          <div class="toggle-format" @click="toggleFormat">
            <span :class="{ active: formato === 'ABC' }">ABC</span>/
            <span :class="{ active: formato === '123' }">123</span>
          </div>

          <button @click="crearNuevaPregunta" class="btn-black-pill">
            Crear <img src="../assets/icon-white.png" class="btn-icon">
          </button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { db } from '../firebase';
import { QrcodeStream } from 'vue3-qrcode-reader';
import { 
  collection, 
  addDoc, 
  query, 
  onSnapshot, 
  orderBy, 
  doc, 
  updateDoc,
  where,
  getDocs
} from 'firebase/firestore';

export default {
components: { QrcodeStream },
  data() {
    return {
      // 1. Recuperamos el ID del canal (prioridad URL, luego LocalStorage)
     canalId: this.$route.query.id || localStorage.getItem('admin_canal_uid'),
        
        // Buscamos 'pin' en la URL, si no, lo recuperamos del storage
        pinSesion: this.$route.query.pin || localStorage.getItem('admin_canal_pin'),
        
        // El nombre del evento también debe ser persistente
        nombreEvento: this.$route.query.nombre || localStorage.getItem('admin_canal_nombre') || 'Evento Activo',
      preguntas: [],
      nuevaPregunta: { titulo: '' },
      permitirComentarios: false,
      opciones: [''],
      formato: 'ABC',
      canalConfig: { color: '#6366f1', logo: '' },
      mostrarModalComentarios: false,
      preguntaSeleccionada: null,
      comentariosActivos: [],
      unsubComentarios: null,
      connected: false,
      mostrarModalConexion: false,
      tabConexion: 'qr', // qr o pin
      pinProyector: '',
      pinDigitsAdmin: ['', '', '', ''],
      proyectorIdActivo: null,
      unsubProyector: null
    }
  },
  mounted() {
    if (!this.canalId) {
      console.error("No se encontró ID de canal, regresando al home...");
      this.$router.push('/');
      return;
    }
    this.escucharPreguntas();
    this.escucharConfiguracionCanal();
    // NUEVO: Recuperar conexión al recargar
    this.recuperarConexionProyector();
  },
  methods: {
    resetPinAdmin() {
      this.pinDigitsAdmin = ['', '', '', ''];
      this.pinProyector = '';
    },

    onPinAdminInput(index, event) {
      const digits = event.target.value.replace(/\D/g, '');
      if (!digits) {
        this.$set(this.pinDigitsAdmin, index, '');
        this.pinProyector = this.pinDigitsAdmin.join('');
        return;
      }

      const chars = digits.split('');
      let lastIndex = index;
      for (let i = 0; i < chars.length && index + i < 4; i++) {
        this.$set(this.pinDigitsAdmin, index + i, chars[i]);
        lastIndex = index + i;
      }
      this.pinProyector = this.pinDigitsAdmin.join('');

      if (lastIndex < 3) {
        this.$nextTick(() => this.$refs.pinInputsAdmin?.[lastIndex + 1]?.focus());
      }

      if (this.pinProyector.length === 4) {
        this.conectarPorPin();
      }
    },

    onPinAdminKeydown(index, event) {
      if (event.key !== 'Backspace') return;
      if (this.pinDigitsAdmin[index]) {
        this.$set(this.pinDigitsAdmin, index, '');
        this.pinProyector = this.pinDigitsAdmin.join('');
        if (index > 0) {
          this.$nextTick(() => this.$refs.pinInputsAdmin?.[index - 1]?.focus());
        }
        return;
      }
      if (index > 0) {
        this.$nextTick(() => this.$refs.pinInputsAdmin?.[index - 1]?.focus());
      }
    },

    // Lógica para detectar el QR (que debería contener el ID del proyector)
    async onDecode(decodedString) {
      // El QR de la web suele ser: https://web.uvoto.com/bind?id=proj_XYZ
      const url = new URL(decodedString);
      const proyectorId = url.searchParams.get("id");
      
      if (proyectorId) {
        await this.vincularProyector(proyectorId);
      }
    },

    async conectarPorPin() {
      if (this.pinProyector.length !== 4) return;
      
      const q = query(
        collection(db, "proyectores"), 
        where("pin", "==", this.pinProyector),
        where("estado", "==", "esperando")
      );
      
      const snap = await getDocs(q);
      if (!snap.empty) {
        const proyectorDoc = snap.docs[0];
        await this.vincularProyector(proyectorDoc.id);
        this.resetPinAdmin();
      } else {
        alert("Pin no válido o pantalla no encontrada");
        this.resetPinAdmin();
      }
    },

    async vincularProyector(id) {
        try {
            const proyectorRef = doc(db, "proyectores", id);
            
            // 1. Guardamos los datos en Firestore
            // Incluimos el nombre del evento y el ID del canal para que el proyector se configure solo
            await updateDoc(proyectorRef, {
            canalId: this.canalId,
            nombreEvento: this.nombreEvento,
            pinCanal: this.pinSesion,
            estado: 'vinculado',
            fechaVinculacion: new Date()
            });
            
            // 2. Guardamos en LocalStorage para persistencia tras recarga
            localStorage.setItem('proyector_vinculado_id', id);

            // 3. Iniciamos el escucha en tiempo real
            // Esto hace que 'this.connected' dependa de la realidad en la base de datos
            this.recuperarConexionProyector(); 
            
            // 4. Feedback visual y cierre
            this.mostrarModalConexion = false;
            
            // Opcional: una pequeña vibración si es móvil
            if (navigator.vibrate) navigator.vibrate(50);

        } catch (e) {
            console.error("Error vinculando:", e);
            alert("No se pudo vincular con la pantalla. Verifica que el código sea correcto.");
        }
        },


        async recuperarConexionProyector() {
      const savedId = localStorage.getItem('proyector_vinculado_id');
      if (savedId) {
        // Escuchamos en tiempo real por si se desconecta desde la PC
        onSnapshot(doc(db, "proyectores", savedId), (snap) => {
          if (snap.exists()) {
            const data = snap.data();
            // Validamos que siga vinculado a este canal específico
            if (data.estado === 'vinculado' && data.canalId === this.canalId) {
              this.connected = true;
              this.proyectorIdActivo = savedId;
            } else {
              this.limpiarEstadoConexion();
            }
          } else {
            this.limpiarEstadoConexion();
          }
        });
      }
    },

    limpiarEstadoConexion() {
      this.connected = false;
      this.proyectorIdActivo = null;
      localStorage.removeItem('proyector_vinculado_id');
    },

    // Actualiza tu método de desconectar para usar la limpieza centralizada
    async desconectarProyector() {
        if (!this.proyectorIdActivo) return;
        try {
            const { deleteDoc } = await import('firebase/firestore'); // Asegúrate de importar deleteDoc
            const proyectorRef = doc(db, "proyectores", this.proyectorIdActivo);
            
            // ELIMINAMOS el documento para que la PC detecte que la sesión murió
            await deleteDoc(proyectorRef);
            
            this.limpiarEstadoConexion();
            this.mostrarModalConexion = false;
        } catch (e) {
            console.error("Error al desconectar y eliminar:", e);
        }
        },
    // Escucha el documento del canal para branding y ID activo
    escucharConfiguracionCanal() {
      onSnapshot(doc(db, "canales", this.canalId), (snap) => {
        if (snap.exists()) {
          this.canalConfig = snap.data();
        }
      });
    },

    // Escucha las preguntas DENTRO del canal específico
    escucharPreguntas() {
        const q = query(
        collection(db, `canales/${this.canalId}/preguntas`), 
        orderBy("fechaCreacion", "desc")
        );
        onSnapshot(q, (snapshot) => {
        this.preguntas = snapshot.docs.map(doc => {
            const data = doc.data();
            // Nota: Para el conteo real en tiempo real sin recargar, 
            // lo ideal es un campo "contadorComentarios" en el doc de la pregunta
            // que se incremente desde el UserView.
            return { id: doc.id, ...data };
        });
        });
    },

    async abrirComentarios(pregunta) {
    this.preguntaSeleccionada = pregunta;
    this.mostrarModalComentarios = true;
    
    // Escuchar comentarios de ESTA pregunta
    const q = query(
      collection(db, `canales/${this.canalId}/preguntas/${pregunta.id}/comentarios`),
      orderBy("fecha", "desc")
    );
    
    this.unsubComentarios = onSnapshot(q, (snap) => {
      this.comentariosActivos = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    });
  },

  cerrarComentarios() {
    this.mostrarModalComentarios = false;
    if (this.unsubComentarios) this.unsubComentarios();
    this.comentariosActivos = [];
  },

    handleAction(pregunta) {
    if (pregunta.estado === 'proyectar') {
      this.proyectarPregunta(pregunta);
    } else if (pregunta.estado === 'ejecucion') {
      this.finalizarVotacion(pregunta.id);
    }
  },

  getStatusText(estado) {
    const textos = { 
      proyectar: 'Proyectar', 
      ejecucion: 'Finalizar', // Cambiamos "En ejecución" por la acción "Finalizar"
      finalizado: 'Finalizado' 
    };
    return textos[estado] || 'Proyectar';
  },

  async finalizarVotacion(preguntaId) {
    try {
      // 1. Marcar la pregunta como finalizada
      const preguntaRef = doc(db, `canales/${this.canalId}/preguntas`, preguntaId);
      await updateDoc(preguntaRef, { 
        estado: 'finalizado',
        activo: false // Ya no se reciben más votos
      });
      
      // 2. Limpiar el puntero en el canal
      const canalRef = doc(db, "canales", this.canalId);
      await updateDoc(canalRef, { 
        preguntaActivaId: null 
      });

    } catch (e) {
      console.error("Error al finalizar:", e);
    }
  },

    async crearNuevaPregunta() {
      if (!this.nuevaPregunta.titulo.trim()) return;
      try {
        const payload = {
          titulo: this.nuevaPregunta.titulo,
          opciones: this.opciones.filter(o => o.trim() !== ''),
          formato: this.formato,
          estado: 'proyectar', // Estado inicial
          fechaCreacion: new Date(),
          votos: this.opciones.reduce((acc, _, i) => ({...acc, [i]: 0}), {}),
          participantes: 0,
          permiteComentarios: this.permitirComentarios
        };

        // GUARDADO CLAVE: Ahora se guarda en la subcolección del canal específico
        await addDoc(collection(db, `canales/${this.canalId}/preguntas`), payload);

        // Reset del formulario
        this.nuevaPregunta.titulo = '';
        this.opciones = [''];
        this.permitirComentarios = false;
      } catch (e) { 
        console.error("Error al crear la pregunta:", e); 
      }
    },

    // Función vital: Notifica al canal qué pregunta deben cargar los usuarios
    async proyectarPregunta(pregunta) {
        // Si ya está en ejecución, no hacemos nada
        if (pregunta.estado === 'ejecucion') return;

        try {
            const canalRef = doc(db, "canales", this.canalId);
            
            // 1. Identificar si hay una pregunta previa en ejecución para finalizarla
            const preguntaAnterior = this.preguntas.find(p => p.estado === 'ejecucion');
            if (preguntaAnterior && preguntaAnterior.id !== pregunta.id) {
            const prevRef = doc(db, `canales/${this.canalId}/preguntas`, preguntaAnterior.id);
            await updateDoc(prevRef, { estado: 'finalizado' });
            }

            // 2. Actualizar el documento del CANAL (lo que ven los usuarios)
            await updateDoc(canalRef, {
            preguntaActivaId: pregunta.id
            });
            
            // 3. Actualizar el estado de la NUEVA pregunta
            const preguntaRef = doc(db, `canales/${this.canalId}/preguntas`, pregunta.id);
            await updateDoc(preguntaRef, { 
            estado: 'ejecucion',
            activo: true // Aseguramos que los usuarios puedan votar
            });
            
        } catch (e) {
            console.error("Error al proyectar:", e);
            alert("Error al proyectar la pregunta");
        }
        },


        async finalizarVotacion(preguntaId) {
        // Función extra por si quieres cerrar una votación sin abrir otra
        const preguntaRef = doc(db, `canales/${this.canalId}/preguntas`, preguntaId);
        await updateDoc(preguntaRef, { estado: 'finalizado' });
        
        // Limpiamos el canal para que los usuarios vean el estado de espera
        const canalRef = doc(db, "canales", this.canalId);
        await updateDoc(canalRef, { preguntaActivaId: null });
        },

    totalVotos(p) {
      return Object.values(p.votos || {}).reduce((a, b) => a + b, 0);
    },

    getStatusText(estado) {
      const textos = { proyectar: 'Proyectar', ejecucion: 'En ejecución', finalizado: 'Finalizado' };
      return textos[estado] || 'Proyectar';
    },

    adjustTextarea(e) {
      e.target.style.height = 'auto';
      e.target.style.height = e.target.scrollHeight + 'px';
    },

    getLabel(index) {
      return this.formato === 'ABC' ? String.fromCharCode(65 + index) : index + 1;
    },

    agregarOpcion() {
      if (this.opciones.length < 10) this.opciones.push('');
    },

    eliminarOpcion(index) {
      this.opciones.splice(index, 1);
    },

    toggleFormat() {
      this.formato = this.formato === 'ABC' ? '123' : 'ABC';
    }
  }
}
</script>

<style scoped>
.uvoto-dark-theme {
  background-color: #1a1a1a;
  color: white;
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.separator-line {
  height: 1px;
  background-color: #f4f4f4; /* Color gris muy claro como en el diseño */
  margin: 15px 0;
  width: 100%;
}

/* Header */
.event-header { text-align: left; margin-bottom: 30px; }
.mini-logo { width: 80px; margin-bottom: 20px; }
.label-evento { font-size: 12px; color: #888; margin: 0; }
.event-title { font-size: 28px; margin: 5px 0; line-height: 1; }
.event-subtitle { font-size: 14px; color: #888; }

/* Dashboard Content */
.empty-state { flex: 1; display: flex; align-items: center; justify-content: center; }
.dashed-box { border: 1px dashed #444; border-radius: 20px; padding: 60px; color: #444; width: 100%; max-width: 400px; text-align: center; }

/* Tarjetas de Pregunta */
.question-card {
  background: white; color: black; border-radius: 22px;
  padding: 25px; margin-bottom: 15px; text-align: left;
  padding-bottom: 12px;
}
.card-title { font-size: 18px; font-weight: 700; margin-bottom: 20px; color: #1a1a1a; }
.card-metrics { display: flex; align-items: center; gap: 15px; font-size: 12px; color: #888; font-weight: 500; }

.metric{
    display: flex;
    align-items: center;
}

.status-pill {
  margin-left: auto; border: none; border-radius: 50px;
  padding: 10px 18px; color: white; display: flex; align-items: center; gap: 8px;
  font-weight: 700; font-size: 13px;
}
.status-pill.proyectar { background: #1a1a1a; }
.status-pill.ejecucion { background: #2ecc71; }
.status-pill.finalizado { background: #e74c3c; }
.pill-icon { width: 14px; }

/* Footer y Creador */
.creator-footer { position: fixed; bottom: 20px; width: 94%; left: 3%; z-index: 10; }
.creator-card { background: white; border-radius: 25px; padding: 22px; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }

.question-textarea {
  width: 100%; border: none; font-size: 15px; resize: none; outline: none;
  color: #333; font-family: inherit; font-weight: 500;
}

/* Opciones Estilo Píldora Dashed */
.options-container { margin-top: 15px; border-top: 1px solid #f2f2f2; padding-top: 15px; }
.option-row { display: flex; align-items: center; margin-bottom: 10px; gap: 5px; }

.option-label {
  background: black; color: white; min-width: 42px; height: 42px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 20px 0 0 20px; font-weight: 700;
}

.option-input-dashed {
  flex: 1; height: 42px; border: 1px dashed #ccc; border-left: none;
  padding: 0 15px; border-radius: 0 20px 20px 0; outline: none; color: #333;
}

/* Botón Eliminar (X en círculo negro) */
.btn-remove-circle {
  background: black; color: white; border: none; width: 22px; height: 22px;
  border-radius: 50%; font-size: 14px; font-weight: bold; cursor: pointer;
  display: flex; align-items: center; justify-content: center; margin-left: 5px;
}

.btn-add { background: none; border: none; font-size: 24px; color: #ccc; cursor: pointer; padding: 0 10px; }

/* Herramientas Inferiores */
.creator-tools { display: flex; justify-content: space-between; align-items: center; margin-top: 15px; }

.checkbox-label { display: flex; align-items: center; cursor: pointer; }
.check-label-text { color: #555; font-size: 13px; font-weight: 600; margin-left: 8px; }

.toggle-format { color: #ccc; cursor: pointer; font-size: 14px; font-weight: 600; }
.toggle-format .active { color: black; }

.btn-black-pill {
  background: #1a1a1a; color: white; border: none; padding: 12px 25px;
  border-radius: 50px; display: flex; align-items: center; gap: 10px; font-weight: 700;
}
.btn-icon { width: 16px; }

.animate-in { animation: fadeInUp 0.4s ease-out; }
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}


/* --- MODAL BOTTOM SHEET --- */
.bottom-sheet-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 100;
  display: flex;
  align-items: flex-end;
}

.bottom-sheet {
  background: white;
  width: 100%;
  height: 80vh;
  max-height: 80vh;
  border-radius: 30px 30px 0 0;
  padding-top: 20px;
  color: #1a1a1a;
  display: flex;
  flex-direction: column;
}

.handle {
  width: 40px; height: 5px; background: #e2e8f0;
  border-radius: 10px; margin: 0 auto 15px;
}

.sheet-title-row {
    width: 90%;
    margin: auto;
  display: flex; justify-content: space-between; align-items: center;
}

.sheet-subtitle { font-size: 13px; color: #888; margin-bottom: 10px; margin-top: 20px; }

.btn-close-sheet {
  background: #f1f5f9; border: none; width: 30px; height: 30px;
  border-radius: 50%; font-size: 20px; cursor: pointer;
}

.comments-list {
  flex: 1; overflow-y: auto; padding-bottom: 40px;
}

.comment-item {
  border-bottom: 1px solid #f1f5f9;
  padding: 15px 0;
  text-align: left;
}

.comment-user-info {
  display: flex; align-items: center; gap: 12px; margin-bottom: 8px;
}

.user-badge {
  width: 35px; height: 35px; border-radius: 50%;
  color: white; display: flex; align-items: center; 
  justify-content: center; font-weight: 800; font-size: 14px;
}

.user-meta { display: flex; flex-direction: column; }
.user-name { font-size: 13px; font-weight: 700; }
.user-vote { font-size: 11px; color: #64748b; }

.comment-text {
  font-size: 14px; line-height: 1.5; color: #334155;
  padding-left: 47px; margin: 0;
}

.empty-comments { text-align: center; padding: 40px; color: #94a3b8; font-size: 14px; }

.clickable { cursor: pointer; transition: opacity 0.2s; }
.clickable:hover { opacity: 0.7; }

/* Animación */
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
.animate-up { animation: slideUp 0.3s ease-out; }

.button-pc{
    width: auto;
    min-width: 30%;
    background: #777777;
    gap: 10px;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px;
    border-radius: 20px;
}


/* --- ESTILOS NUEVOS --- */

.button-pc.is-conected {
  background: #2ecc71; /* Verde como en tu imagen */
}

/* Tabs */
.tabs-conexion {
    display: flex;
    background: #f1f5f9;
    border-radius: 12px;
    padding: 4px;
    margin: 20px auto; /* Mantiene el centrado horizontal */
    width: 90%; 
    max-width: 400px; /* Evita que en pantallas muy anchas se estire demasiado */
    box-sizing: border-box;
}

.tabs-conexion button {
    flex: 1; /* Esto obliga a ambos botones a ocupar exactamente el 50% cada uno */
    border: none;
    padding: 12px 5px; /* Padding vertical constante */
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    background: transparent;
    color: #64748b;
    transition: all 0.3s ease;
    white-space: nowrap; /* Evita que el texto salte a otra línea */
    display: flex;
    align-items: center;
    justify-content: center;
}

.tabs-conexion button.active {
    background: #1a1a1a;
    color: white;
    /* Evitamos usar font-weight: 900 aquí para que el ancho no varíe 
       si ya definimos 600 en el estado normal */
}



/* QR y PIN */
.qr-reader-container {
  width: 100%;
  max-width: 300px; /* Tamaño máximo para que no ocupe toda la pantalla en tablets */
  aspect-ratio: 1 / 1; /* Relación 1x1 fija */
  margin: 0 auto; /* Centrado horizontal */
  border-radius: 20px;
  overflow: hidden;
  background: #000;
  position: relative;
  flex-shrink: 0; /* Evita que se aplaste al hacer scroll */
  border: 4px solid #f1f5f9;
}

.camera-stream {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Asegura que la cámara llene el cuadrado sin deformar */
}

/* Marco visual dentro del lector */
.scan-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 15px;
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.3); /* Efecto oscurecer fuera del marco */
}

.pin-entry-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
  padding: 20px 0;
  width: 90%;
  margin: auto;
  align-items: center;
}

.pin-grid-admin {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 6px 0 2px;
}

.pin-box-admin {
  width: 56px;
  height: 60px;
  border-radius: 14px;
  border: 1.5px solid #d1d5db;
  text-align: center;
  font-size: 24px;
  font-weight: 800;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease;
}

.pin-box-admin:focus {
  border-color: #111;
  background: #fff;
}

.btn-conectar-negro {
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 18px;
  border-radius: 15px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
}

.hint {
  text-align: center;
  color: #888;
  font-size: 12px;
  margin-top: 10px;
}


/* Contenedor principal del contenido en el modal */
.conexion-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* El scroll ocurre aquí */
  padding-bottom: 40px;
  /* Suavizar el scroll en móviles */
  -webkit-overflow-scrolling: touch;
}

/* Instrucciones */
.proyector-instructions {
    width: 90%;
    margin: auto;
  margin-top: 30px;
  text-align: left;
  padding: 0 5px; /* Pequeño respiro lateral */
}

.inst-divider {
  height: 1px;
  background: #eee;
  margin-bottom: 25px;
}

.inst-title {
  font-size: 18px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
}

.inst-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step-item {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}

.step-icon {
  background: #1a1a1a;
  color: white;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.step-item p {
  font-size: 14px;
  color: #444;
  line-height: 1.4;
  margin: 0;
}

.capabilities-list {
  margin-top: 10px;
  padding-left: 0;
  list-style: none;
}

.capabilities-list li {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tech-note {
  margin-top: 30px;
  background: #f8f9fa;
  padding: 15px;
  border-radius: 12px;
  font-size: 12px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1.3;
}

/* Overlay para la cámara para que se vea más pro */
.camera-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  border: 2px solid rgba(255,255,255,0.2);
  box-shadow: inset 0 0 100px rgba(0,0,0,0.5);
  pointer-events: none;
}


/* Transición de altura para el modal */
.bottom-sheet {
  transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.connected-state-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-top: 20px;
}

.status-online {
  color: #2ecc71;
  font-weight: 700;
  font-size: 14px;
  margin-top: 10px;
}

.pc-icon-wrapper {
  position: relative;
  width: 60px;
  height: 60px;
  background: #f8fafc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #2ecc71;
  border-radius: 50%;
  animation: ripple 2s infinite;
}

@keyframes ripple {
  0% { transform: scale(0.8); opacity: 1; }
  100% { transform: scale(1.6); opacity: 0; }
}

.btn-outline-danger {
  width: 100%;
  background: transparent;
  color: #e74c3c;
  border: 2px solid #e74c3c;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}
</style>
